import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import historyActions from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import SelectButton from "../../component/SelectButton/SelectButton";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";
import api from "../../config/api";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class AddRole extends Component {
  state = {
    code: "",
    selectedRole: "",
    userRoles: [],
    isLoading: true,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
    this.fetchUserRoles();
  }

  fetchUserRoles = async () => {
    const { setAlertMessage } = this.props;
    try {
      const userRoles = await api.getAllRoles();
      this.setState({
        userRoles: userRoles.data.lstUserRoles,
        isLoading: false,
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchUserRoles : null,
      });
    }

    this.setState({isLoading: false})
  };

  submitRole = async (ev) => {
    const { userRoles, selectedRole, code } = this.state;
    const { user, setAlertMessage } = this.props;

    try {
      if (!selectedRole) throw new Error("Please select a role");
      if (!code) throw new Error("Code is required");

      const role = userRoles.find(
        (roles) => roles.roleName.toLowerCase() === selectedRole.toLowerCase()
      );
      this.setState({ isLoading: true });

      const body = {
        userRole: {
          id: user.id,
          userName: user.User.UserName,
          roleId: role.id,
        },
        code,
      };

      await api.userRole(body, user.token);
      setAlertMessage({ type: "success", message: "Successfull!" });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.submitRole(ev)
          : null,
      });
    }
    this.setState({ isLoading: false, code: "" });
  };

  checkPrimaryRole = (type) => {
    const { user } = this.props;
    const primaryId = user.primaryRole && user.primaryRole.roleId;

    if (type === "member") return primaryId !== 4;
    if (type === "staff") return primaryId === 1;
    if (type === "employer") return primaryId === 2;
  };

  render() {
    const { code, selectedRole, isLoading } = this.state;
    const { user } = this.props;
    const primaryId = user.primaryRole && user.primaryRole.roleId;

    return (
      <Container>
        {isLoading && <CustomLoader text="Please wait" />}
        <PageHead containerStyles={{ width: "100%" }} title="ADD ROLE" />
        <Row>
          <Col className="p-0 pr-md-1 my-2" xs={12}>
            <SelectButton text="Select Role" disabled={true} />
          </Col>
          {(this.checkPrimaryRole("member") ||
            this.checkPrimaryRole("staff")) && (
            <Col className="p-0 my-2 px-sm-1 px-md-1" sm={6} md={3}>
              <SelectButton
                onClick={() => this.setState({ selectedRole: "employer" })}
                active={selectedRole === "employer"}
                containerStyles={{ justifyContent: "center" }}
                text="Employer"
              />
            </Col>
          )}
          {(this.checkPrimaryRole("member") ||
            this.checkPrimaryRole("staff") ||
            this.checkPrimaryRole("employer")) && (
            <Col className="p-0 my-2 px-sm-1 px-md-1" sm={6} md={3}>
              <SelectButton
                onClick={() => this.setState({ selectedRole: "member" })}
                active={selectedRole === "member"}
                containerStyles={{ justifyContent: "center" }}
                text="Member"
              />
            </Col>
          )}
          {this.checkPrimaryRole("member") && (
            <Col className="p-0 my-2 px-sm-1 px-md-1" sm={6} md={3}>
              <SelectButton
                onClick={() => this.setState({ selectedRole: "staff" })}
                active={selectedRole === "staff"}
                containerStyles={{ justifyContent: "center" }}
                text="Staff"
              />
            </Col>
          )}
          {(this.checkPrimaryRole("member") ||
            this.checkPrimaryRole("employer")) && (
            <Col className="p-0 my-2 px-sm-1 px-md-1" sm={6} md={3}>
              <SelectButton
                onClick={() => this.setState({ selectedRole: "agent" })}
                active={selectedRole === "agent"}
                containerStyles={{ justifyContent: "center" }}
                text="Agent"
              />
            </Col>
          )}
        </Row>
        <InputComp
          name="password"
          containerStyles={{ width: "100%" }}
          placeholder="Code"
          value={code}
          onChange={(e) => this.setState({ code: e.target.value })}
        />
        <Row className="justify-content-center my-2">
          <Col className="p-0" md={3}>
            <CustomButton
              buttonClasses="btn-block"
              buttonText="Submit"
              onClick={this.submitRole}
              disabled={primaryId === 4}
            />
            {primaryId === 4 && (
              <p className="text-danger text-center">
                You can not add more roles
              </p>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  setHistory: historyActions.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddRole);
